module.exports = __webpack_public_path__ + "img/purple-blue.bff763f9.svg";